import { ClientDetails } from 'features/utils/types';
import { apiInstance } from './api';

export type CreateNewOfferProps = {
  configId: number;
  promoCode?: string;
  totalPrice: number;
  simulatorData: {
    roofInclination: number;
    electricityConsumptionPerYearKwh: number;
    electricityConsumptionPerYearEuro: number;
    installationExpectedPower: number;
    installationExpectedProduction: number;
  };
  clientDetail: ClientDetails;
  offerDetail: {
    solarPanels: {
      id: number;
      count: number;
    };
    inverters: {
      id: number;
      count: number;
    };
    installationType: {
      id: number;
      count: number;
    };
    batteries?: {
      id: number;
      count: number;
    };
    carCharger?: {
      id: number;
      count: number;
    };

    // En cas de client B2B, vu qu'il n'y a pas de batterie ni de chargeur, deux paramètres peuvent être passés pour indiquer le désir du client de recevoir de la documentation
    wantBatteryInformation?: boolean;
    wantCarChargerInformation?: boolean;
  };
};

export const createNewOffer = async (offer: CreateNewOfferProps) =>
  apiInstance.post(`/createNewOffer`, { ...offer });
